import {Component, Input} from "@angular/core";
import {NavigationState} from "../../helpers/navigation-state";


@Component({
    selector: "nv-list-navigation",
    templateUrl: "./nv-list-navigation.component.html"
})


export class NvListNavigationComponent {
    @Input() nav:NavigationState;
    @Input() showLabel:boolean = false;
}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-list-navigation/nv-list-navigation.component.ts